


export const TEMPLATE_INPUT_PROPS = [
    "description",
	"title",
	"solver",
	"access",
	"modelerTitle",
	"modelerDescription",
	"modelerAccess",
    "topics",
    "industries",
]


export function SanitizeTemplateInput(template){
    let newTemplate = {...template};
    let templateKeys = Object.keys(newTemplate);
    for(var i = 0; i< templateKeys.length; i++){
        if(!TEMPLATE_INPUT_PROPS.includes(templateKeys[i])){
            delete newTemplate[templateKeys[i]];
        }
    }
    return newTemplate;
}